// add lazy-load supported
import LazyLoad from "vanilla-lazyload";
document.addEventListener('DOMContentLoaded', function () {
    let myLazyLoad = new LazyLoad();
});

// to top
function scrollTo(to, duration = 700) {
    const
        element = document.scrollingElement || document.documentElement,
        start = element.scrollTop,
        change = to - start,
        startDate = +new Date(),
        // t = current time
        // b = start value
        // c = change in value
        // d = duration
        easeInOutQuad = function (t, b, c, d) {
            t /= d / 2;
            if (t < 1) return c / 2 * t * t + b;
            t--;
            return -c / 2 * (t * (t - 2) - 1) + b;
        },
        animateScroll = function () {
            const currentDate = +new Date();
            const currentTime = currentDate - startDate;
            element.scrollTop = parseInt(easeInOutQuad(currentTime, start, change, duration));
            if (currentTime < duration) {
                requestAnimationFrame(animateScroll);
            } else {
                element.scrollTop = to;
            }
        };
    animateScroll();
}

document.addEventListener('DOMContentLoaded', function () {
    let btn = document.querySelector('#toTop');
    if (btn) {
        window.addEventListener('scroll', function () {
            // show if > 599px
            if (pageYOffset > 100) {
                btn.classList.add('show');
                // remove
            } else {
                btn.classList.remove('show');
            }
        });

        // to top on click
        btn.onclick = function (click) {
            click.preventDefault();
            scrollTo(0, 400);
        }
    }
});

document.addEventListener("DOMContentLoaded", function () {
    if (!document.querySelector(".banner")) {
        const main = document.querySelector("main");
        if (main) {
            main.style.marginTop = "100px";
        }
    }
});

// mobile burger menu
let burger = document.querySelector('.burger');
let menu_body = document.querySelector('.menu');
if (burger) {
    burger.onclick = function () {
        menu_body.classList.toggle('active');
        burger.classList.toggle('active')
    }
}

// adaptive table class
function coverTable() {
    let table = document.querySelectorAll('table');
    for (let i = table.length - 1; i >= 0; i--) {
        let cover = document.createElement('div');
        cover.classList.add('cover-table');
        table[i].parentNode.insertBefore(cover, table[i]);
        cover.appendChild(table[i]);
    }
}

coverTable();


// faq
const faq_container = document.querySelector('.faq-container');
if (faq_container) {
    faq_container.addEventListener('click', function (e) {
        const items = document.querySelectorAll('.faq-container-content')
        const target = e.target
        Array.from(items).forEach(item => {
            if (item != target) {
                item.classList.remove('show')
            }
        })
        target.classList.toggle('show')
    })
}

// iframe on click
(function () {
    'use strict';

    function loadGame() {
        let wrap = document.getElementById('js_game');
        if (wrap) {
            let btn = wrap.getElementsByTagName('button')[0];

            function onClick() {
                let frame = document.createElement('iframe');
                let src = wrap.getAttribute('data-game');

                frame.setAttribute('src', src);
                btn.removeEventListener('click', onClick);
                wrap.innerHTML = '';
                wrap.appendChild(frame);
            }

            if (btn) {
                btn.addEventListener('click', onClick);
            }
        }
    }

    loadGame();
})();

// import custom scripts
import './custom-app'
